import React from "react";
// import { Link } from "gatsby";

import Layout from "../components/layout";
import SEO from "../components/seo";
import Koperasi from "../images/koperasi-indonesia.png";
import Line from "../images/line.png";
import Dashboard from "../images/dashboard.png";

function PortfolioPage() {
  return (
    <Layout>
      <SEO
        keywords={[`rabbi`, `mayoza`, `rabbi fijar mayoza`, `pollycarpus`, `portfolio`, `portofolio`]}
        title="Portfolio"
      />
      <div className="flex-1 w-full bg-white">
        <section className="sm:text-left lg:text-left px-4 py-8 mx-auto md:px-8 md:py-16 max-w-5xl">
          <h1 className="text-2xl tracking-tight font-semibold text-gray-900 sm:text-3xl md:text-4xl">
            <span className="block xl:inline">Projects</span>
          </h1>
          <div className="mt-5 sm:mt-8 sm:flex sm:justify-start lg:justify-start">
            <p className="font-base">
              Throughout my university period, I worked on various tech projects as well as became the project manager. Luckily, I had the opportunity to have internship at Central Bank of Indonesia, joining software engineer team in driving the digital transformation by keeping their system up with current technology. There, I developed backend systems, contributed in product engineering through SDLC, ensuring the product to meet the quality and user&apos;s requirements. My journey later introduced me to be a generalist. After all, I realize that what I really want to do is not only the engineering part, but also the design, research, and planning. 
            </p>
          </div>
        </section>
        <section className="sm:text-left lg:text-left px-4 py-8 mx-auto md:px-8 max-w-5xl">
          <a className="group hover:bg-white hover:shadow-lg hover:border-transparent block md:grid md:grid-cols-12 gap-4 mb-8" href="https://www.kopkarcocacolajatim.com" rel="noopener noreferrer" target="_blank">
            <div className="group-hover:text-gray-900 md:col-span-2">
              <p className=" text-left md:text-right font-medium">1</p>
            </div>
            <div className="block max-w-md md:col-span-4">
              <figure className="group-hover:text-gray-900">
                <img alt="Kopkar Coca-Cola Jatim" src={Koperasi} />
              </figure>
            </div>
            <div className=" block group-hover:text-gray-900 md:col-span-4">
              <h4 className="font-semibold text-lg mb-4">kopkarcocacolajatim.com</h4>
              <p className="font-light text-base mb-4"> A homepage with web-based application accessible by all members of Koperasi Karyawan Coca-Cola Jawa Timur.</p>
              <p className="font-light text-base text-gray-400"> February 2021</p>
            </div>
          </a>
          <a className="group hover:bg-white hover:shadow-lg hover:border-transparent block md:grid md:grid-cols-12 gap-4 mb-8" href="https://lin.ee/RpNHrjL" rel="noopener noreferrer" target="_blank">
            <div className="group-hover:text-gray-900 md:col-span-2">
              <p className=" text-left md:text-right font-medium">2</p>
            </div>
            <div className="block max-w-md md:col-span-4">
              <figure className="group-hover:text-gray-900">
                <img alt="Kopkar Coca-Cola Jatim" src={Line} />
              </figure>
            </div>
            <div className=" block group-hover:text-gray-900 md:col-span-4">
              <h4 className="font-semibold text-lg mb-4">Kapten Polly</h4>
              <p className="font-light text-base mb-4"> A personal assistant chatbot running on Line Messenger platform. Currently the bot has COVID-19 rapid test feature, which is done by asking some questions to user.</p>
              <p className="font-light text-base text-gray-400"> December 2020</p>
            </div>
          </a>
          <a className="group hover:bg-white hover:shadow-lg hover:border-transparent block md:grid md:grid-cols-12 gap-4 mb-8" href="https://s.id/vbwDG" rel="noopener noreferrer" target="_blank">
            <div className="group-hover:text-gray-900 md:col-span-2">
              <p className=" text-left md:text-right font-medium">3</p>
            </div>
            <div className="block max-w-md md:col-span-4">
              <figure className="group-hover:text-gray-900">
                <img alt="Kopkar Coca-Cola Jatim" src={Dashboard} />
              </figure>
            </div>
            <div className=" block group-hover:text-gray-900 md:col-span-4">
              <h4 className="font-semibold text-lg mb-4">Jatim Covidmeter</h4>
              <p className="font-light text-base mb-4"> A dashboard for monitoring the spread of COVID-19 and its fatality in East Java.</p>
              <p className="font-light text-base text-gray-400"> August 2020</p>
            </div>
          </a>
        </section>
      </div>
    </Layout>
  );
}

export default PortfolioPage;
